import styled from "styled-components";

export const ContentWrapper = styled.div`
 display: flex;
 flex-direction: column;
 gap: 24px; 
`; 

export const RowWrapper = styled.div`
 display: flex;
 flex-direction: row;
 justify-content: space-between;
`; 

export const ColumnWrapper = styled.div`
 display: flex;
 flex-direction: column;
 gap: 0; 
`; 